(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ra-weekend-announcement')) {
  customElements.define('ra-weekend-announcement', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        clearTimeout(this.timer);
        const now = Date.now();
        const start = Date.parse('2026-10-02T13:00:00Z');
        const end = Date.parse('2026-10-04T21:59:00Z');
        const active = this.dataset.eligible === 'true' && now >= start && now < end;
        const state = String(active);
        if (this.dataset.active !== state) this.dataset.active = state;
        const message = this.querySelector('.ra-weekend-message');
        if (message) message.hidden = !active;
        const next = now < start ? start : now < end ? end : null;
        if (next && this.dataset.eligible === 'true') {
          this.timer = setTimeout(this.refresh, Math.min(next - now + 100, 2147483647));
        }
      };
      this.refresh();
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
